import { FC, ReactNode } from 'react'
import SeparationArrows from '@images/SeparationArrows.svg'
import CompletedCap from '@images/CompletedCup.svg'
import NotCompletedCap from '@images/NotCompletedCup.svg'
import { Day, WeekStatus } from '../types'

const getBgColor = (status: WeekStatus, dayType?: Day['type']): string => {
	if (status === 'notFinished') {
		if (dayType === 'skipped') {
			return '#E1E2DD'
		}
		if (dayType === 'finished') {
			return '#7F86D3'
		}
		if (dayType === 'training') {
			return '#3F51B5'
		}
		if (dayType === 'current') {
			return '#DCF831'
		}
		return '#DADADA'
	}
	if (status === 'finished') {
		if (dayType === 'skipped') {
			return '#E1E2DD'
		}
		return '#7F86D3'
	}
	if (status === 'notStarted' || status === 'last') {
		return '#DADADA'
	}
	return '#DADADA'
}

const createCircle = (day: Day, status: WeekStatus): ReactNode => {
	const bgColor = getBgColor(status, day.type)
	const textColor = day.type === 'skipped' ? '#666A63' : '#FFFFFF'

	return (
		<div
			key={day.id}
			onClick={day.item.onClick}
			style={{ background: bgColor, color: textColor }}
			className={`w-[33px] h-[33px] text-white rounded-[60px] flex items-center justify-center`}>
			{day.item.title}
		</div>
	)
}

export const WeekDescription: FC<{ days: Day[]; status: WeekStatus }> = ({ days, status }) => {
	console.log(days)
	const topElements: ReactNode[] = []
	const bottomElements: ReactNode[] = []
	const arrow = <img src={SeparationArrows} alt='Продолжение' className={'w-[22px]'} />

	if (days.length >= 4) {
		topElements.push(createCircle(days[0], status))
		for (let i = 1; i < 4; i++) {
			topElements.push(arrow)
			topElements.push(createCircle(days[i], status))
		}
	}

	const capSrc = status === 'finished' ? CompletedCap : NotCompletedCap
	const capAlt = ''
	if (days.length >= 7) {
		bottomElements.push(createCircle(days[4], status))
		bottomElements.push(arrow)
		bottomElements.push(createCircle(days[5], status))
		bottomElements.push(arrow)
		bottomElements.push(createCircle(days[6], status))
		bottomElements.push(arrow)
		bottomElements.push(<img key='cap' src={capSrc} alt={capAlt} className={'w-[33px]'} />)
	}

	const width: number = Math.min(document.documentElement.clientWidth, 500) - 89
	console.log(width)

	return (
		<div
			style={{ width: width }}
			className={`h-[108px] px-4 py-3 bg-white mt-1 rounded-[15px] flex flex-col`}>
			<div className='flex w-full justify-between'>{topElements}</div>
			<div className='flex w-full justify-between mt-auto'>{bottomElements}</div>
		</div>
	)
}
